module.exports = __webpack_public_path__ + "static/media/btnNotification.1a70e062.svg";